const PAYMENT_REFUND_PAYER = {
	producer: 'PRODUCER',
	membo: 'MEMBO',
};

export default PAYMENT_REFUND_PAYER;